export default function useStyles() {
    return  theme => ({
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            padding: 20,
        },
        '@media only screen and (max-width: 600px)': {
            paper: {
                width: '90%',
            },
        },
        buttonCancelar: {
            color: 'gray'
        },
        buttonRemover: {
            color: 'white',
            backgroundColor: '#159B78',
            '&:hover': {
                backgroundColor: '#159B78bf',
            },
        },
        tituloModalRemove: {
            marginBottom: '20px'
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            marginBottom: 40,
            width: '100%',
        },
        multilineColor: {
            color: 'rgb(118, 118, 118) !important',
            borderBottomColor: '#159B78 !important',
            "&::after": {
                borderBottomColor: '#159B78 !important',
            }
        },
    });
}